/* @flow */

import * as React from 'react';

// Utils
import { homeRoute } from 'src/shared/app/base/route/setting/routeSettings';
import { scrollToTop } from 'src/shared/core/util/browserUtil';
import { getRoutePath } from 'src/shared/app/base/route/util/routeUtils';
import { keywordParam } from 'src/shared/app/market/settings/marketSettings';
import {
  getKeywordEnabled,
  getKeywordLabel,
} from 'src/shared/domain/keyword/util/keywordUtils';

// Components
import TagLink from 'src/shared/ui/component/button/Tag/TagLink';

// Type
import type { Keyword } from 'src/shared/domain/keyword/type/keywordTypes';
import { useDispatch } from 'react-redux';
import {
  invalidateMarket,
  setMarketQuery,
} from 'src/shared/app/market/action/marketActions';

type Props = {
  keyword: Keyword,
};

const KeywordTagLink = ({ keyword }: Props): React.Node => {
  const dispatch = useDispatch();

  const label = getKeywordLabel(keyword);
  const isEnabled = getKeywordEnabled(keyword);

  const homePath = getRoutePath(homeRoute);

  const path = `${homePath}?${keywordParam}=${label}`;

  const handleClick = () => {
    scrollToTop();

    dispatch(setMarketQuery(label));
    dispatch(invalidateMarket());
  };

  return (
    <TagLink to={path} onClick={handleClick} isInactive={isEnabled === false}>
      {label}
    </TagLink>
  );
};

export default React.memo<Props>(KeywordTagLink);
